import { RouteBasePath } from 'components/mainLayout/routeBasePath';

export const quickLinks: { label: string; link: string }[] = [
  {
    label: 'admin.label.account_manage',
    link: RouteBasePath.MANAGE_ACCOUNT_PAGE_PATH
  },
  {
    label: 'admin.label.category_manage',
    link: RouteBasePath.CATEGORY_MANAGE_PAGE_PATH
  },
  {
    label: 'admin.label.product_manage',
    link: RouteBasePath.PRODUCT_MANAGE_PAGE_PATH
  },
  {
    label: 'admin.label.content_manage_homepage',
    link: RouteBasePath.HOMEPAGE_CONTENT_MANAGE_PATH
  },
  {
    label: 'admin.label.content_manage_best_seller_products',
    link: RouteBasePath.BEST_SELLER_PRODUCT_MANAGE_PATH
  },
  {
    label: 'admin.label.content_manage_featured_products',
    link: RouteBasePath.FEATURED_PRODUCT_MANAGE_PATH
  },
  {
    label: 'admin.label.news_manage',
    link: RouteBasePath.NEWS_MANAGE_PAGE_PATH
  }
];
